import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { Marker, Circle } from '@react-google-maps/api';

import InactiveAircraftRegistrationLabel, {
  SOSAircraftRegistrationLabel,
  StandardAircraftRegistrationLabel
} from './AircraftRegistrationLabel';
import { getStatusColourFromPointTime } from '../../../../../../util/getStatusColourFromPointTime';

export const AircraftTrackPoint = ({
  position,
  trackStatus,
  pointStatus,
  radius,
  hideMapRadiusShading,
  zIndex,
  latestPointTime,
  isV2,
  ...markerProps
}) => {
  const fillColour = getStatusColourFromPointTime(latestPointTime);

  const getRegistrationLabelComponent = () => {
    if (trackStatus === 'SOS') {
      return SOSAircraftRegistrationLabel;
    }

    // Active aircraft (both V1 and V2) get green/amber labels && V2 gets standard labels based on status
    // V2 aircraft ignores trackStatus
    if (trackStatus === 'ACTIVE' || isV2) {
      return StandardAircraftRegistrationLabel;
    }

    return InactiveAircraftRegistrationLabel;
  };

  const RegistrationLabel = getRegistrationLabelComponent();

  return (
    <Fragment>
      <Marker position={position} {...markerProps} zIndex={zIndex}>
        {markerProps.aircraftRegistration && (
          <RegistrationLabel
            position={position}
            label={markerProps.aircraftRegistration}
            zIndex={zIndex}
            isV2={isV2}
            mainColour={fillColour}
          />
        )}
      </Marker>

      {pointStatus === 'RADIUS' && (
        <Circle
          center={position}
          radius={radius}
          zIndex={zIndex}
          options={{
            strokeColor: '#ff0000',
            strokeOpacity: 0.85,
            strokeWeight: 2,
            fillColor: '#ff0000',
            fillOpacity: hideMapRadiusShading ? 0 : 0.2
          }}
        />
      )}
    </Fragment>
  );
};

AircraftTrackPoint.propTypes = {
  position: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  trackStatus: PropTypes.string,
  radius: PropTypes.number,
  hideMapRadiusShading: PropTypes.bool,
  aircraftId: PropTypes.string,
  pointStatus: PropTypes.string,
  zIndex: PropTypes.number,
  latestPointTime: PropTypes.number,
  isV2: PropTypes.bool
};

export default memo(AircraftTrackPoint);
